/**
 * Replica of Product.php
 */

export enum DesignType {
  Custom = 0,
  Prefabricated = 1,
  Delegated = 2
}

export type Product = {
  type: ProductType
  finished?: boolean
  design_type?: DesignType
  price?: number
}

/**
 * Replica of ProductType.php
 */
enum ProductType {
  /**
   * Rouwpagina
   * @deprecated use PageStandard instead
   */
  Online = 0,
  /**
   * Advertentie
   * @deprecated use Obituary instead
   */
  Newspaper = 1,
  /**
   * Rouwkaart
   * @deprecated use Card instead
   */
  Postcard = 2,
  Digital = 3,

  PageStandard = 10, // Standaard rouwpagina
  PageExtended = 11, // Uitgebreide rouwpagina
  PageUpgradeStandardToExtended = 12, //Upgrade van standaard naar uitgebreid

  Card = 20, // Rouwkaart

  Obituary = 30, // Rouwadvertentie

  /**
   * Order kosten
   */
  OrderCosts = 100,
  /**
   * Opmaak kosten
   * vrij in te vullen aan de hand van de hoeveelheid werk. Dit wordt eerst in de prijsopgave ook gecommuniceerd naar de klant
   */
  DesignCosts = 101,

}

export default ProductType

/**
 * Standard product ordering for display purposes
 */
export const productStepOrder = [ProductType.Card, ProductType.Obituary, ProductType.PageStandard];

export function getTitle(type: ProductType) {
  switch (type) {
    case ProductType.PageExtended:
    case ProductType.PageStandard:
      return 'Rouwpagina';
    case ProductType.Obituary:
      return 'Advertentie';
    case ProductType.Card:
      return 'Rouwkaart';
    case ProductType.Digital:
      return 'Digitale rouwkaart';
  }
}

export function getPrice(type: ProductType) {
  switch (type) {
    case ProductType.PageStandard:
    case ProductType.PageExtended:
      return '€19,35 (incl. BTW)';
    case ProductType.Obituary:
      return '€50,00 (incl. BTW)';
    case ProductType.Card:
      return '€5,00 (incl. BTW)';
    case ProductType.Digital:
      return '€5,00 (incl. BTW)';
  }
}
